import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { App } from './App';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Portfolio } from './pages/Portfolio';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminBlogEdit } from './pages/admin/AdminBlogEdit';
import { AdminBlogCreate } from './pages/admin/AdminBlogCreate';
import { ProtectedRoute } from './components/ProtectedRoute';
// ScrollToTop component that scrolls the window to the top whenever the route changes
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function AppRouter() {
  return <BrowserRouter data-id="element-4">
      <ScrollToTop data-id="element-5" />
      <Routes data-id="element-6">
        <Route path="/" element={<App data-id="element-8">
              <Home data-id="element-9" />
            </App>} data-id="element-7" />
        <Route path="/services" element={<App data-id="element-11">
              <Services data-id="element-12" />
            </App>} data-id="element-10" />
        <Route path="/portfolio" element={<App data-id="element-14">
              <Portfolio data-id="element-15" />
            </App>} data-id="element-13" />
        <Route path="/about" element={<App data-id="element-17">
              <About data-id="element-18" />
            </App>} data-id="element-16" />
        <Route path="/contact" element={<App data-id="element-20">
              <Contact data-id="element-21" />
            </App>} data-id="element-19" />
        <Route path="/blog" element={<App data-id="element-23">
              <Blog data-id="element-24" />
            </App>} data-id="element-22" />
        <Route path="/blog/:id" element={<App data-id="element-26">
              <BlogPost data-id="element-27" />
            </App>} data-id="element-25" />
        <Route path="/admin/login" element={<AdminLogin data-id="element-29" />} data-id="element-28" />
        <Route path="/admin" element={<ProtectedRoute data-id="element-31">
              <AdminDashboard data-id="element-32" />
            </ProtectedRoute>} data-id="element-30" />
        <Route path="/admin/blog/create" element={<ProtectedRoute data-id="element-34">
              <AdminBlogCreate data-id="element-35" />
            </ProtectedRoute>} data-id="element-33" />
        <Route path="/admin/blog/edit/:id" element={<ProtectedRoute data-id="element-37">
              <AdminBlogEdit data-id="element-38" />
            </ProtectedRoute>} data-id="element-36" />
      </Routes>
    </BrowserRouter>;
}